//2022.6までIE対応が必要。それ以降は外しでOK
// import "core-js/stable";
// import "regenerator-runtime/runtime";

import Main from "./common/main";

const main = new Main();
